import React from "react";
import { Form, Modal, Input, Select } from "antd";
import FormValidator, { requiredField } from "../../../../models/formValidator";
import { UserRole } from "../../../../models";

const defaultSettings = {
  formValidator: {
    firstName: [
      requiredField("first name"),
      {
        max: 20,
        message: "Maksimum je {0} znakova!".replace("{0}", String(20))
      }
    ],
    lastName: [
      requiredField("last name"),
      {
        max: 20,
        message: "Maksimum je {0} znakova!".replace("{0}", String(20))
      }
    ],
    email: FormValidator.email,
    username: [
      requiredField("user name"),
      {
        min: 6,
        message: "Minimum je {0} znakova!".replace("{0}", String(6))
      }
    ],
    role: [requiredField("role")]
  }
};

// eslint-disable-next-line max-lines-per-function
const CreateAdminPopup = ({
  form,
  onDismiss,
  settings,
  isVisible,
  loading,
  onSubmit
}) => {
  const handleCreate = () => {
    form.validateFields((error, values) => {
      if (!error) {
        onSubmit(values, status => {
          if (status) {
            form.resetFields();
            onDismiss();
          }
        });
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onDismiss();
  };

  return (
    <Modal
      title={"Kreiraj novog administratora"}
      visible={isVisible}
      onCancel={handleCancel}
      okText={"Kreiraj"}
      onOk={handleCreate}
      confirmLoading={loading}
    >
      <Form layout="vertical">
        <Form.Item label={"Korisničko ime"}>
          {form.getFieldDecorator("username", {
            rules: settings.formValidator.username
          })(
            <Input
              placeholder={"Korisničko ime"}
              name="username"
            />
          )}
        </Form.Item>
        <Form.Item label={"Ime"}>
          {form.getFieldDecorator("firstName", {
            rules: settings.formValidator.firstName
          })(
            <Input
              placeholder={"Ime"}
              name="firstName"
            />
          )}
        </Form.Item>
        <Form.Item label={"Prezime"}>
          {form.getFieldDecorator("lastName", {
            rules: settings.formValidator.lastName
          })(
            <Input
              placeholder={"Prezime"}
              name="lastName"
            />
          )}
        </Form.Item>
        <Form.Item label="Email">
          {form.getFieldDecorator("email", {
            rules: settings.formValidator.email
          })(<Input placeholder="Email" name="email" />)}
        </Form.Item>
        <Form.Item label={"Uloga"}>
          {form.getFieldDecorator("role", {
            rules: settings.formValidator.role
          })(
            <Select
              getPopupContainer={trigger => trigger.parentElement}
              placeholder={"Uloga"}
              className="not-control"
            >
              <Select.Option value={UserRole.admin}>
                {"Operater"}
              </Select.Option>
              <Select.Option value={UserRole.superAdmin}>
                {"Administrator"}
              </Select.Option>
            </Select>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

CreateAdminPopup.defaultProps = {
  settings: defaultSettings,
  isVisible: false,
  loading: false
};

export default Form.create()(CreateAdminPopup);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdminPage/CreateAdminPopup/CreateAdminPopup.tsx